export const kerkLegend={
    'denominatie':{
        'Christelijke Gereformeerde Kerk': '#AACFE2',
        'Christian Science Church': '#F9C179',
        'Doopsgezinde Sociëteit': '#B5DE92',
        'Evangelisch Lutherse Kerk': '#42A53D',
        'Gereformeerde Gemeente (in Nederland)': '#F7A09F',
        'Gereformeerde Kerk (vrijgemaakt)': '#E12C2E',
        'Gereformeerde Kerken': '#3081B7',
        'Nederlandse Hervormde Kerk': '#744CA0',
        'Nederlandse Protestantenbond': '#CAB5D6',
        'Oud-Katholieke Kerk': '#FAFB9F',
        'Protestantse Kerk Nederland': '#4E154F',
        'Remonstrantse Broederschap': '#B46539',
        'Rooms-katholieke Kerk': '#FA8715',
        'Overig': '#888815',
    },
    'vorm': {
        'basiliek': '#E62F31',
        'basiliek/centraalbouw': '#4A8ABE',
        'centraalbouw': '#5AB358',
        'hallenkerk': '#AA6239',
        'kruisbasiliek': '#FA8715',
        'kruiskerk': '#FAFB43',
        'pseudobasiliek': '#F389C1',
        'zaalkerk': '#9D5BA8',
        'onbepaald': '#9E9F9F',
    },
    'stijl': {
        'neogotiek': '#2f4f4f',
        'modernisme - functionalisme': '#8b4513',
        'expressionisme': '#006400',
        'traditionalisme': '#000080',
        'neorenaissance': '#ff0000',
        'eclecticisme': '#00ced1',
        'neoromaans': '#ffa500',
        'classicisme': '#ffff00',
        'gotiek': '#00ff00',
        'renaissance': '#0000ff',
        'romaans':'#d8bfd8',
        'neoclassicisme': '#ff00ff',
        'neobarok': '#ff69b4',
        'rationalisme': '#1e90ff',
        'overig': '#C0C0C0',
    },
    'monument': {
        'Gemeentelijk Monument': '#E22C2E',
        'Provinciaal Monument': '#4989BD',
        'Rijksmonument': '#5AB358',
        'geen monumenten status': '#9D5BA8',
        'onbekend': '#FA8715',
    },
    'huidige_bestemming': {
        'kerk': '#1B9E77',
        'anders': '#D95F02'
    },
    'periode': {
        '-1000': '#FAF4EA',
        '1000-1300': '#FAE7CA',
        '1300-1600': '#F8D4A4',
        '1600-1800': '#F8BE8C',
        '1800-1850': '#F89465',
        '1850-1900': '#EC7056',
        '1900-1945': '#D64031',
        '1945-': '#B61515',
        'onbekend': '#D3D3D3'
    }
};

